import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = import.meta.env.VITE_SUPABASE_URL  ?? '';
const supabaseKey  = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

export const isCloudMode = !!supabaseUrl;

export const supabase = isCloudMode
  ? createClient(supabaseUrl, supabaseKey, {
      auth: {
        persistSession:    true,
        autoRefreshToken:  true,
        detectSessionInUrl: true,
      },
    })
  : null;

export type SupabaseClient = typeof supabase;
